import classNames from 'classnames/bind';
import React from 'react';
import colors from '../../scss/_colors-export.module.scss';

import styles from './Divider.module.scss';

const cx = classNames.bind(styles);

interface DividerProps {
  color?: string;
  vertical?: boolean;
  className?: string;
}

const Divider = ({ color = colors.tertiary300, vertical, className }: DividerProps): React.ReactElement => {
  return (
    <span
      style={{ backgroundColor: `${color}` }}
      className={cx('body', className, { vertical })}
      data-testid="divider"
    />
  );
};

export default Divider;
